module.exports = __webpack_public_path__ + "static/media/Siddharth-Simharaju.9cad6ea3.jpg";